import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/idle_fee_bill_settlements',
  component: Management,
  redirect: '/idle_fee_bill_settlements/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/idle_fee_bill_settlements/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listIdleFeeBillSettlements,
        activeMenu: '/ev_charging_station_settlements'
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/idle_fee_bill_settlements/ListTable'),
          meta: {
            auth: Auth.listIdleFeeBillSettlements,
            tabName: 'all'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/idle_fee_bill_settlements/DetailLayout'),
      meta: {
        auth: Auth.showIdleFeeBillSettlement,
        activeMenu: '/ev_charging_station_settlements'
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/idle_fee_bill_settlements/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showIdleFeeBillSettlement,
            activeMenu: '/ev_charging_station_settlements'
          }
        }
      ]
    }
  ]
}
